import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { StartArcadiaGreenButtonConnectionResponseDto } from "../dto/arcadia-green-button.dto"
import { arcadiaGreenButtonService } from "../services/arcadia-green-button.service"

type StartArcadiaGreenButtonConnectionParams = {
  proposalId: string
  siteId: string
}

export const useStartArcadiaGreenButtonConnection = (): UseMutationResult<
  StartArcadiaGreenButtonConnectionResponseDto,
  unknown,
  StartArcadiaGreenButtonConnectionParams,
  unknown
> => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, siteId }) =>
      arcadiaGreenButtonService.startConnection(siteId, proposalId),
    onSuccess: (_data, { siteId }) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.arcadiaGreenButton.site(siteId),
      })
    },
  })
}
